module.exports = __webpack_public_path__ + "img/mask_rule.ac11e42d.jpeg";